import React, { useState, useEffect } from 'react';


import { MdDeleteOutline } from "react-icons/md";
import './mendHandler.css';


const MendHandler = () => {
    const [mend, setMend] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const fetchMend = async () => {
          try {
            const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/mend'); // backUrl
            const responseData = await response.json();
            setMend(responseData.mend);
            setIsLoaded(true);

          } catch(err) {
            console.log(err)
          }
        }
        fetchMend();
      },[]);
      
  const deleteMend = async (mendId) => {

    const confirm = window.confirm('Are you sure to delete this mend!. ')
    if (!confirm) {
      return
    }

    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/mend/${mendId}`, {
        method: 'DELETE'
      })
    } catch (err) {
      console.log(err.message)
    }

    setMend(prevMend => prevMend.filter(m => m.id !== mendId))
  }
  return (
    <main className='mendHandler-lists-container'>
      <table className='mendHandler-table-controller'>   
        <thead>
          <tr className='table-tr'>
            <th>Name</th>
            <th>Title</th>
            {/* <th>Article</th> */}
            
            <th id='mendTable-edit'>Edit/Delete</th>
          </tr>    
        </thead>
        <tbody className='mendHandler-tbody'>
          {isLoaded && mend.map((m,index) => (
            <tr key={index} className='mendHandler-lists-tr' > 
              <td>{m.name}</td>
              <td>{m.title}</td>
              {/* <td>{m.article}</td> */}
              {/* <td>{m.image}</td> */}
              
             
                                           
              <td id='mendTable-delete'>
                <MdDeleteOutline onClick={() => deleteMend(m.id)} style={{fontSize: '25px', color: 'red', marginRight: '15px'}}/>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>     
  )
}
export default MendHandler;